import React from 'react'
import PropTypes from 'prop-types'
import ExpandLess from '@mui/icons-material/ExpandLess'

const ExpandLessIcon = ({ height, width, ...more }) => {
	
	return (
		<ExpandLess
			height={height}
			width={width}
			{...more}
		/>
	)
}

ExpandLessIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default ExpandLessIcon
